import { render } from "./idea.vue?vue&type=template&id=08553f3d&scoped=true"
import script from "./idea.vue?vue&type=script&lang=js"
export * from "./idea.vue?vue&type=script&lang=js"

import "./idea.vue?vue&type=style&index=0&id=08553f3d&scoped=true&lang=less"

import exportComponent from "D:\\STD7159\\源码管理\\前端\\stgd.oa.ows.inernetweb\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08553f3d"]])

export default __exports__